export var EmailDeliverabilityStatus = /*#__PURE__*/ function(EmailDeliverabilityStatus) {
    EmailDeliverabilityStatus["IDLE"] = "IDLE";
    EmailDeliverabilityStatus["CHECKING"] = "CHECKING";
    EmailDeliverabilityStatus["VALID"] = "VALID";
    EmailDeliverabilityStatus["INVALID"] = "INVALID";
    return EmailDeliverabilityStatus;
}({});

//# sourceMappingURL=email-validation-types.js.map